import React from "react";
import Container from "react-bootstrap/Container";
import { useTranslation } from "react-i18next";

import { Title, ContactCardPorto, ContactCardApulia } from "./common";
import styles from "../assets/styles/contacts.module.scss";

export function Contacts() {
  const { t, i18n } = useTranslation("contacts");

  return (
    <section className={styles.contactsContainer} id="contacts">
      <Container data-aos="fade-up">
        <Title title={t("title")} />
        
        <div className="d-flex gap-4 flex-column flex-md-column flex-lg-row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <ContactCardPorto iframeMinHeight="350px" addressAlt={t("address")} phoneAlt={t("phone")} />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <ContactCardApulia iframeMinHeight="350px" addressAlt={t("address")} phoneAlt={t("phone")} />
          </div>
        </div>
      </Container>
    </section>
  );
}
